import { getProjectLangSwitcherActiveCode } from './projectLangSwitcher';

export type DafesBilingualTargetLang = 'en' | 'ru';

export const getDafesBilingualTargetLang = (uiLang: string): DafesBilingualTargetLang => {
  const active = getProjectLangSwitcherActiveCode(uiLang);
  return active === 'en' ? 'ru' : 'en';
};

export const getDafesBilingualSwitcherKey = (
  isBilingual: boolean,
  uiLang: string
): string => {
  const active = getProjectLangSwitcherActiveCode(uiLang);

  if (isBilingual) {
    return active === 'ru'
      ? 'bilingual_switcher.delete_ru'
      : 'bilingual_switcher.delete_en';
  }

  return `bilingual_switcher.add_${getDafesBilingualTargetLang(uiLang)}`;
};
export const getDafesBilingualDescKey = (uiLang: string): string =>
  `project_edit.bilingual_second_desc_1_${getDafesBilingualTargetLang(uiLang)}`;
import { getProjectLangSwitcherActiveCode } from './projectLangSwitcher';

export type DafesBilingualTargetLang = 'en' | 'ru';

export const getDafesBilingualTargetLang = (uiLang: string): DafesBilingualTargetLang => {
  const active = getProjectLangSwitcherActiveCode(uiLang);
  return active === 'en' ? 'ru' : 'en';
};

export const getDafesBilingualSwitcherKey = (
  isBilingual: boolean,
  uiLang: string
): string => {
  const active = getProjectLangSwitcherActiveCode(uiLang);

  if (isBilingual) {
    return active === 'ru'
      ? 'bilingual_switcher.delete_ru'
      : 'bilingual_switcher.delete_en';
  }

  return `bilingual_switcher.add_${getDafesBilingualTargetLang(uiLang)}`;
};
export const getDafesBilingualDescKey = (uiLang: string): string =>
  `project_edit.bilingual_second_desc_1_${getDafesBilingualTargetLang(uiLang)}`;
